import React, {Component} from 'react';
import Actions from './common/Actions';

const Retouch = (props) => {

  return (
    <div className="adjust">
      <Actions
        {...props}
      />
      <div id="retouch-controls"/>
    </div>
  );
}

export default Retouch
